import { render, staticRenderFns } from "./FooterConnection.vue?vue&type=template&id=60d92386&"
import script from "./FooterConnection.vue?vue&type=script&lang=js&"
export * from "./FooterConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports